export default __webpack_public_path__ + "static/media/delete_icn_circle.97c47987.svg";